import { render } from "./Widget10.vue?vue&type=template&id=44c0268f"
import script from "./Widget10.vue?vue&type=script&lang=ts"
export * from "./Widget10.vue?vue&type=script&lang=ts"
script.render = render

export default script